import { defineMessages, MessageDescriptor } from 'react-intl';

const messages: Record<string, MessageDescriptor> = defineMessages({
	noAccessNotice: {
		id: 'auth.noAccessNotice',
		defaultMessage: 'You must be logged in to see this page'
	},
	login: {
		id: 'auth.login',
		defaultMessage: 'Login'
	},
	logout: {
		id: 'auth.logout',
		defaultMessage: 'Logout'
	}
});

export default messages;
